import {
  IconBrain,
  IconPalette,
  IconUser,
  IconCamera,
  IconRobot,
  IconPhoto,
  IconBook,
  IconDeviceMobile,
  IconShirt,
} from "@tabler/icons-react";
import { Tool } from "@/components/ToolsGrid";
import { SERVICE_PRICES } from "@/lib/ownedServices";
import { PRICING } from "@/constants/pricing";
import { HAIR_COLORS } from "@/constants/hairColors";

export const tools: Tool[] = [
  // Primary Tools - Clear starting points
  {
    title: "AI Color Analysis",
    description: "Instant professional grade color analysis",
    premium: true,
    serviceId: "color-analysis",
    price: SERVICE_PRICES["color-analysis"],
    icon: IconRobot,
    link: "/ai-color-analysis",
    image: "/colorAnalysisSamples/colorAnalysisOp.mp4",
    buttonText: "Get Analysis",
  },
  {
    title: "Free Color Quiz",
    description: "Take our quiz to discover your perfect color palette",
    icon: IconBrain,
    link: "/color-analysis-quiz",
    buttonText: "Take Quiz",
    image: "/toolSamples/colorAnalysisQuiz.png",
  },
  {
    title: "Outfit Check",
    description: "Upload your outfit and get instant AI feedback — free",
    icon: IconCamera,
    link: "/outfit-check",
    buttonText: "Check My Outfit",
  },
  {
    title: "AI Hair Color Changer",
    description: `See yourself in ${HAIR_COLORS.length} hair colors instantly — free`,
    icon: IconPalette,
    link: "/ai-hair-color-try-on",
    buttonText: "Try Hair Colors",
  },
  {
    title: "Browse Color Palettes",
    description: "Explore all seasonal color palettes and outfit ideas",
    icon: IconPalette,
    link: "/color-palette",
    buttonText: "View Palettes",
    image: "/toolSamples/outfits.png",
  },

  // Quick Tests
  {
    title: "Skin Tone Test",
    description: "Find your undertone with simple tests",
    icon: IconUser,
    link: "/skin-tone-test",
    buttonText: "Take Test",
  },
  {
    title: "Undertone Quiz",
    description: "Discover if you're warm, cool, or neutral",
    icon: IconUser,
    link: "/undertone-quiz",
    buttonText: "Take Quiz",
  },
  {
    title: "Gold or Silver Test",
    description: "Find out if gold or silver jewelry suits you better",
    icon: IconUser,
    link: "/gold-or-silver-jewelry-test",
    buttonText: "Take Test",
  },

  // Learning & Guides
  {
    title: "What Is My Color Season?",
    description: "Complete guide to finding your color season",
    icon: IconPalette,
    link: "/color-analysis-quiz",
    buttonText: "Take Quiz",
  },
  {
    title: "How to Do Color Analysis",
    description: "Complete DIY guide to color analysis at home",
    icon: IconBook,
    link: "/how-to-do-color-analysis",
    buttonText: "Read Guide",
  },
  {
    title: "Color Seasons Chart",
    description: "Explore all 12 and 16 seasonal palettes",
    icon: IconPalette,
    link: "/color-seasons-chart",
    buttonText: "View Chart",
  },
  {
    title: "Compare Seasons",
    description: "Compare different seasonal color palettes side by side",
    icon: IconPalette,
    link: "/seasonal-comparison-tool",
    buttonText: "Compare Seasons",
  },
  {
    title: "Best Color Analysis Apps",
    description: "Compare top color analysis apps and find the best one",
    icon: IconDeviceMobile,
    link: "/best-color-analysis-app",
    buttonText: "View Comparison",
  },
  {
    title: "Best Color Analysis Software",
    description: "Compare professional color analysis software options",
    icon: IconDeviceMobile,
    link: "/best-color-analysis-software",
    buttonText: "View Comparison",
  },
  {
    title: "Best Hair Colors for You",
    description: "Find the perfect hair color for your skin tone and season",
    icon: IconPalette,
    link: "/best-hair-colors-for-skin-tone",
    buttonText: "Find Hair Colors",
  },
  {
    title: "Best Makeup Colors for You",
    description: "Discover lipstick, eyeshadow and blush colors for your tone",
    icon: IconPalette,
    link: "/best-makeup-colors-for",
    buttonText: "Find Makeup Colors",
  },
  {
    title: "Best Colors for Your Skin Tone",
    description: "What colors look best on you based on skin tone",
    icon: IconPalette,
    link: "/best-colors-for-skin-tone",
    buttonText: "Find Your Colors",
  },

  // Specialized Analysis
  {
    title: "Color Analysis for Men",
    description: "Specialized color analysis tools for men",
    icon: IconUser,
    link: "/seasonal-color-analysis-for-men",
    buttonText: "Get Analysis",
  },
  {
    title: "Color Analysis for Non-Binary",
    description: "Inclusive color analysis for all gender identities",
    icon: IconUser,
    link: "/seasonal-color-analysis-for-non-binary",
    buttonText: "Get Analysis",
  },

  // Advanced Tools
  {
    title: "AI Outfit Generator",
    description: "See yourself in 30+ AI-generated outfits instantly",
    premium: true,
    serviceId: "outfits",
    price: SERVICE_PRICES["outfits"],
    icon: IconShirt,
    link: "/ai-outfit-generator",
    buttonText: "Generate Outfits",
    image: "/swatchPreviews/girlCasual1.png",
  },
  {
    title: "Virtual Draping",
    description: "Try on different colors virtually with AI",
    premium: true,
    serviceId: "draping",
    price: PRICING.ADVANCED_DRAPING.BASE_PRICE,
    icon: IconPhoto,
    link: "/virtual-color-draping",
    buttonText: "Try Draping",
    image: "/drapeSamples/advancedPrice/fullDemo.mp4",
  },
  {
    title: "Kibbe Body Type Test",
    description: "Discover your perfect body type and style",
    icon: IconBrain,
    premium: true,
    serviceId: "kibbe",
    price: SERVICE_PRICES["kibbe"],
    link: "/kibbe-body-type-test",
    buttonText: "Take Test",
    image: "/kibbe/kibbe.mp4",
  },
];
